import { render } from "./RfcMessages.vue?vue&type=template&id=68af7b53"
import script from "./RfcMessages.vue?vue&type=script&lang=js"
export * from "./RfcMessages.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__